import React from 'react'

const Table = (props) => {
  const classes = `table table-${props.classname}`
  return <table className={classes}>{props.children}</table>
}

export default Table